export default __webpack_public_path__ + "static/media/JobSix15.789e9960.jpg";